import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_LEAVE_APPLY} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const LeaveApply = lazy(() =>
  import('../../../screens/LeaveApply')
    .then(module => ({default: module.LeaveApply})));

const LeaveApplyNavigation = [
  {
    path: ROUTE_LEAVE_APPLY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <LeaveApply />
      </Suspense>
    ),
  },
];

export default LeaveApplyNavigation;
